import React from "react";
import { elakayAutoText as text } from "../pageInside/dataElakay";
import { productShopIds } from "./productShop";
export default function ProductShopChooser({ product, shop, onChange }) {
  const ids = productShopIds(product);
  const shops = (product?.associatedShops || []).filter((s) => ids.includes(String(s._id)));
  if (shops.length < 2) return null;
  return <label className="d-block p-2">{text("h_multishop_available", "Available in these shops")}
    <select className="form-control" value={String(shop?._id || "")} onChange={(event) => onChange(event.target.value)}>
      {shops.map((s) => <option key={s._id} value={String(s._id)}>{s.name}</option>)}
    </select>
  </label>;
}
